import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6f71933e170f5bb3afc23eecf7ab5096.jpg"
          alt="CICHORZ développement informatique Paris"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-950/80 via-navy-900/70 to-navy-950/85"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 md:px-10 text-center">
        <div
          className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8">
            <i className="ri-map-pin-line text-white/70 text-sm"></i>
            <span className="text-white/80 text-sm font-medium">Programmation Informatique · Paris, France</span>
          </div>

          {/* Title */}
          <h1 className="font-heading font-bold text-white leading-tight mb-6" style={{ fontSize: 'clamp(2.5rem, 5vw, 4rem)' }}>
            Développement informatique<br />
            <span className="text-white/80">et solutions digitales</span>
          </h1>

          {/* Subtitle */}
          <p className="text-white/70 text-lg md:text-xl leading-relaxed max-w-2xl mx-auto mb-10">
            CICHORZ propose des services de <strong className="text-white font-medium">programmation informatique</strong> pour les entreprises et les particuliers. Des solutions fiables, performantes et adaptées à chaque besoin.
          </p>

          {/* CTA buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-white text-navy-900 font-semibold px-8 py-3.5 rounded-full hover:bg-gray-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Discuter de votre projet
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/a-propos"
              className="inline-flex items-center gap-2 border border-white/40 text-white font-medium px-8 py-3.5 rounded-full hover:bg-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              En savoir plus
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/40 text-xs tracking-widest uppercase">Défiler</span>
        <i className="ri-arrow-down-line text-white/40 text-lg"></i>
      </div>
    </section>
  );
}
